exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectable {\n  width: 50%;\n  height: 120px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #f2f2f2;\n  color: #5d5f62;\n  border-radius: 5px;\n  text-align: center;\n  padding: 0;\n  border: none;\n  margin: 0 10px; }\n  .selectable:disabled {\n    background-color: #f2f2f2 !important;\n    color: #b3b3b3 !important; }\n  .selectable:hover {\n    background-color: #0150e3;\n    color: white; }\n  .selectable md-icon {\n    font-size: 46px;\n    width: 46px;\n    height: 46px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agregar-insumo-dialog/agregar-insumo-dialog.component.scss
// module id = ../../../../../src/app/components/agris/agris-detalle-insumo-page/agregar-insumo-dialog/agregar-insumo-dialog.component.scss
// module chunks = 0